// delayManager.js
const initialDelays = [1000, 2000, 3000, 4000, 5000];
let delays = [...initialDelays];

export function getRandomDelay() {
  if (delays.length === 0) {
    delays = [...initialDelays];
  }
  const idx = Math.floor(Math.random() * delays.length);
  const val = delays[idx];
  delays.splice(idx, 1);
  return val;
}